import { string } from "prop-types"
import React from "react"

export default function PricingRowTVA({ amount }) {
  return (
    <td>
      <p>{amount}</p>
    </td>
  )
}

PricingRowTVA.propTypes = {
  amount: string
}
